import { ajaxRetry } from '../lib-api/ajaxRetry';
import { ResponseObj } from '../lib-api/services/base';
import { DemoBankScenario } from '../models/demobankScenarios';

export type DemoBankClient = {
  getUsers: (query: string, request?: typeof ajaxRetry) => Promise<ResponseObj<DemoBankScenario[]>>;
};

export const demoBankClient: DemoBankClient = {
  getUsers: async (query: string, request = ajaxRetry) => {
    return request<DemoBankScenario[]>({
      headers: { Accept: 'application/json' },
      method: 'GET',
      url: `https://cdn.tink.se/link/demobank-users/users.json`,
    });
  },
};
